import { render, staticRenderFns } from "./TableCourierCheckPrice.vue?vue&type=template&id=0025e599"
import script from "./TableCourierCheckPrice.vue?vue&type=script&lang=js"
export * from "./TableCourierCheckPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports